var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandItoC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .icon-ito-1 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1);\r\n      }\r\n\r\n      .icon-ito-2 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-3);\r\n      }\r\n\r\n      .icon-ito-3 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-4);\r\n      }\r\n\r\n      .icon-ito-4 {\r\n        fill: url(#_\uC0C8_\uADF8\uB77C\uB514\uC5B8\uD2B8_\uACAC\uBCF8_1-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 82.42,
    y1: 107.37,
    x2: 26.01,
    y2: 50.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f89cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3f9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-2",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 92.83,
    y1: 96.96,
    x2: 36.42,
    y2: 40.55,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-3",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 103,
    y1: 86.79,
    x2: 46.59,
    y2: 30.38,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1-4",
    "data-name": "\\uC0C8 \\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8 \\uACAC\\uBCF8 1",
    x1: 94.89,
    y1: 94.89,
    x2: 38.49,
    y2: 38.49,
    xlinkHref: "#_\\uC0C8_\\uADF8\\uB77C\\uB514\\uC5B8\\uD2B8_\\uACAC\\uBCF8_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-ito-1",
    d: "m24.41,39.48h6.27v26.04h-6.27v-26.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-ito-4",
    d: "m41.7,44.66h-7.04v-5.18h20.37v5.18h-7.07v20.86h-6.27v-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-ito-2",
    d: "m56.72,52.36c0-8.54,4.83-13.37,11.94-13.37s11.94,4.87,11.94,13.37-4.83,13.65-11.94,13.65-11.94-5.11-11.94-13.65Zm17.5,0c0-5.04-2.14-8.02-5.57-8.02s-5.53,2.98-5.53,8.02,2.1,8.26,5.53,8.26,5.57-3.19,5.57-8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-ito-3",
    d: "m97.5,105H7.5c-4.14,0-7.5-3.36-7.5-7.5V7.5C0,3.36,3.36,0,7.5,0h90c4.14,0,7.5,3.36,7.5,7.5v90c0,4.14-3.36,7.5-7.5,7.5ZM7.5,5c-1.38,0-2.5,1.12-2.5,2.5v90c0,1.38,1.12,2.5,2.5,2.5h90c1.38,0,2.5-1.12,2.5-2.5V7.5c0-1.38-1.12-2.5-2.5-2.5H7.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandItoC);
export default __webpack_public_path__ + "static/media/brand-ito-c.376557823bae740002a39af157d6c3a4.svg";
export { ForwardRef as ReactComponent };